import { UserCareerHistoryBase } from "domain/model/base";

export default class UserCareerHistory extends UserCareerHistoryBase {};
